import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { clearReliableTimeout, setReliableTimeout } from './reliabletimer';
import { getTimestamp, now } from 'owa-datetime';

const taskTimers: { [key: string]: string } = {};

/**
 * Passed task runs every frequencyInMinutes minutes until the expiry. In expiry is not given it will run indefinitely
 *  The first time it will run at the closest first minute, the args can be passed later
 * @param action
 * @param passedId
 * @param frequencyInMinutes or X
 * @param expiryTimeStamp
 */
export default function repeatActionEveryXMinutes(
    action: () => void,
    passedId: string,
    frequencyInMinutes: number = 1,
    expiryTimeStamp?: number
): () => void {
    const id = `${passedId}_${frequencyInMinutes.toString()}`;
    if (taskTimers[id]) {
        // If it already exists, clear it
        clearReliableTimeout(taskTimers[id]);
    }
    return () => runAction(action, id, frequencyInMinutes, expiryTimeStamp);
}

function runAction(
    action: () => void,
    id: string,
    frequencyInMinutes: number = 1,
    expiryTimeStamp?: number
): void {
    taskTimers[id] && clearReliableTimeout(taskTimers[id]);

    const timeNowInMilliSec = getTimestamp(now());

    if (expiryTimeStamp && expiryTimeStamp <= timeNowInMilliSec) {
        taskTimers[id] && clearReliableTimeout(taskTimers[id]);
        relinquishTimerActionWithId(id);
        return;
    }

    // run all the tasks currently present in the queue
    action && action();

    // Get the next closest interval slot start to the current time stamp
    const frequencyInMs: number = TimeConstants.MillisecondsIn1Min * frequencyInMinutes;
    let ceilingMinuteTimeStamp: number =
        Math.ceil(timeNowInMilliSec / frequencyInMs) * frequencyInMs;

    if (ceilingMinuteTimeStamp <= timeNowInMilliSec) {
        ceilingMinuteTimeStamp++; // Add 1 if the next timeStamp is same or lesser than the current time stamp, because we have not rounded
        // less than will happen in a very rare case when ceil does not work
    }

    // The next heartbeat should occur when the next heartbeat is either the exipration time stamp
    // or it should happen when the next minute exactly ticks
    const nextBeatTimeInMilliseconds = expiryTimeStamp
        ? Math.min(expiryTimeStamp, ceilingMinuteTimeStamp)
        : ceilingMinuteTimeStamp;
    const differenceInMilliSec = nextBeatTimeInMilliseconds - timeNowInMilliSec;
    taskTimers[id] = setReliableTimeout(() => {
        runAction(action, id, frequencyInMinutes, expiryTimeStamp);
    }, differenceInMilliSec);
}

export function relinquishTimerActionWithId(userId: string, frequencyInMinutes: number = 1) {
    const id = `${userId}_${frequencyInMinutes}`;
    if (!!taskTimers[id]) {
        clearReliableTimeout(taskTimers[id]);
        delete taskTimers[id];
        taskTimers[id] = undefined;
    }
}
